import { IPricingUi } from '../data/entities/pricing';
import { _404 } from './handlers';
import { IConfiguredHttp } from './http';

export interface IPricingApi {
	getPricingByPropertyId: (id: string) => Promise<IPricingUi[]>;
	updatePricingByPropertyId: (id: string, pricing: IPricingUi[]) => Promise<boolean>;
}

const pricingApiFactory = (http: IConfiguredHttp, prefix = ''): IPricingApi => ({
	getPricingByPropertyId(id) {
		return http.get(`${prefix}/portal/property/${id}`).catch(_404([]));
	},
	updatePricingByPropertyId(id, pricing) {
		return http.post(`${prefix}/portal/property/${id}`, pricing);
	}
});

export default pricingApiFactory;
